import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule, JwtModuleOptions } from '@auth0/angular-jwt';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BreadcrumbsModule, LayoutModule } from 'angular-admin-lte';
import { LoadingPageModule, MaterialBarModule } from 'angular-loading-page';
import { MomentModule } from 'angular2-moment';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerModule } from 'ngx-spinner';
import { adminLteConf } from './admin-lte.conf';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { AuthService } from './auth/auth.service';
import { LoggedGuardService } from './auth/logged-guard.service';
import { RoleAdministratorGuardService } from './auth/role-administrator-guard.service';
import { RoleInstructorGuardService } from './auth/role-instructor-guard.service';
import { RoleInstructorOrAdministratorGuardService } from './auth/role-instructor-or-administrator-guard.service';
import { RoleStudentGuardService } from './auth/role-student-guard.service';
import { RoleStudentOrTutorGuardService } from './auth/role-student-or-tutor-guard.service';
import { RoleTutorGuardService } from './auth/role-tutor-guard.service';
import { RoleTutorOrAdministratorGuardService } from './auth/role-tutor-or-administrator-guard.service';
import {
  RoleAdministratorOrTutorOrInstractorGuardService
} from './auth/role-tutor-or-instructor-or-administrator-guard.service';
import { AddOraLaboratorioModalComponent } from './components/add-ore-laboratorio-modal/add-ora-laboratorio-modal.component';
import {
  AddStudentProvaFinaleModalComponent
} from './components/add-student-prova-finale-modal/add-student-prova-finale-modal.component';
import { AnswerModalComponent } from './components/answer-modal/answer-modal.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { KoModalPrenotazioneComponent } from './components/ko-modal-prenotazione/ko-modal-prenotazione.component';
import { KoModalComponent } from './components/ko-modal/ko-modal.component';
import { OkModalPrenotazioneComponent } from './components/ok-modal-prenotazione/ok-modal-prenotazione.component';
import { OkModalComponent } from './components/ok-modal/ok-modal.component';
import {
  PrenotaProvaFinaleModalComponent
} from './components/prenota-prova-finale-modal/prenota-prova-finale-modal.component';
import { StoricoProvaFinaleModalComponent } from './components/storico-prova-finale-modal/storico-prova-finale-modal.component';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { CoreModule } from './core/core.module';
import { InterceptorsService } from './interceptor/interceptors.interceptor';
import { ListAuleModule } from './pages/administrator-page/aula/list/list-aule.module';
import { ListCorsiLaureaModule } from './pages/administrator-page/corso-laurea/list/list-corsi-laurea.module';
import {
  DashboardAdministratorModule
} from './pages/administrator-page/dashboard-administrator/dashboard-administrator.module';
import { DashboardAdvisorModule } from './pages/administrator-page/dashboard-advisor/dashboard-advisor.module';
import { DashboardInstructorModule } from './pages/administrator-page/dashboard-instructor/dashboard-instructor.module';
import {
  DashboardManagerDidatticoModule
} from './pages/administrator-page/dashboard-manager-didattico/dashboard-manager-didattico.module';
import { DashboardTutorModule } from './pages/administrator-page/dashboard-tutor/dashboard-tutor.module';
import {
  CaricaVotiPlacementModule
} from './pages/administrator-page/funzionalita/carica-voti-placement/carica-voti-placement.module';
import {
  CaricaVotiProvaFinaleModule
} from './pages/administrator-page/funzionalita/carica-voti-prova-finale/carica-voti-prova-finale.module';
import {
  DownloadStudentiPlacementModule
} from './pages/administrator-page/funzionalita/download-studenti-placement/download-studenti-placement.module';
import {
  GeneraGruppiStudioModule
} from './pages/administrator-page/funzionalita/genera-gruppi-studio/genera-gruppi-studio.module';
import {
  RegistrazioneSistemaModule
} from './pages/administrator-page/funzionalita/registrazione-sistema/registrazione-sistema.module';
import { ListGruppiStudioModule } from './pages/administrator-page/gruppo-studio/list/list-gruppi-studio.module';
import {
  AppelliLaboratorioLezioneTutoraggioModule
} from './pages/administrator-page/laboratorio-lezione-tutoraggio/appelli/appelli-laboratori-lezione-tutoraggio.module';
import {
  ListLaboratorioLezioneTutoraggioModule
} from './pages/administrator-page/laboratorio-lezione-tutoraggio/list/list-laboratori-lezione-tutoraggio.module';
import { ListLanguageLevelModule } from './pages/administrator-page/language-level/list/list-language-level.module';
import { LogOperazioneModule } from './pages/administrator-page/log-operazione/log-operazione.module';
import { ListProveFinaliModule } from './pages/administrator-page/prova-finale/list/list-prove-finali.module';
import { ListSessioniOlaModule } from './pages/administrator-page/sessione-ola/list/list-sessioni-ola.module';
import { StatisticheModule } from './pages/administrator-page/statistiche/statistiche.module';
import { ListUtentiModule } from './pages/administrator-page/utente/list/list-utenti.module';
import { ElencoProveModule } from './pages/student-page/elenco-prove/elenco-prove.module';
import { GroupModule } from './pages/student-page/group/group.module';
import { GroupsModule } from './pages/student-page/groups/groups.module';
import { HomeModule } from './pages/student-page/home/home.module';
import { InstructorModule } from './pages/student-page/instructor/instructor.module';
import { InstructorsModule } from './pages/student-page/instructors/instructors.module';
import { ListPrenotazioniModule } from './pages/student-page/laboratorio/list-prenotazioni/list-prenotazioni.module';
import {
  PrenotazioneLaboratorioModule
} from './pages/student-page/laboratorio/prenotazione-laboratorio/prenotazione-laboratorio.module';
import { ModificaProfiloModule } from './pages/student-page/modifica-profilo/modifica-profilo.module';
import { PrenotazioniEsamiModule } from './pages/student-page/prenotazioni-esami/prenotazioni-esami.module';
import { SelfStudyModule } from './pages/student-page/self-study/self-study.module';
import { TutorModule } from './pages/student-page/tutor/tutor.module';
import { TutorsModule } from './pages/student-page/tutors/tutors.module';
import { MaterialModule } from './shared/material.module';
import { SharedComponentsModule } from './shared/shared-component.module';

export function jwtTokenGetter() {
  return 'TODO';
}
// tslint:disable-next-line: max-line-length
// PAGES
// COMPONENTS
// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: variable-name
const JWT_Module_Options: JwtModuleOptions = {
  config: {
    tokenGetter: jwtTokenGetter,
  },
};
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    CoreModule,
    JwtModule.forRoot(JWT_Module_Options),
    LayoutModule.forRoot(adminLteConf),
    LoadingPageModule,
    MaterialBarModule,
    NgxSmartModalModule.forRoot(),
    NgxSpinnerModule,
    BreadcrumbsModule,
    HomeModule,
    DashboardAdministratorModule,
    DashboardAdvisorModule,
    DashboardManagerDidatticoModule,
    LogOperazioneModule,
    StatisticheModule,
    DashboardInstructorModule,
    DashboardTutorModule,
    SelfStudyModule,
    PrenotazioneLaboratorioModule,
    ListPrenotazioniModule,
    GroupsModule,
    GroupModule,
    ElencoProveModule,
    InstructorModule,
    InstructorsModule,
    TutorsModule,
    TutorModule,
    ModificaProfiloModule,
    PrenotazioniEsamiModule,
    // ADMINISTRATOR
    ListUtentiModule,
    ListAuleModule,
    ListLanguageLevelModule,
    ListProveFinaliModule,
    ListCorsiLaureaModule,
    ListGruppiStudioModule,
    ListSessioniOlaModule,
    ListLaboratorioLezioneTutoraggioModule,
    AppelliLaboratorioLezioneTutoraggioModule,
    CaricaVotiPlacementModule,
    CaricaVotiProvaFinaleModule,
    RegistrazioneSistemaModule,
    GeneraGruppiStudioModule,
    DownloadStudentiPlacementModule,
    SharedComponentsModule,
    MaterialModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorsService,
      multi: true,
    },
    // {
    //   provide: APP_BASE_HREF,
    //   useValue: '/cla-angular'
    // },
    // BnNgIdleService,
    NgxSmartModalService,
    AuthService,
    RoleStudentGuardService,
    RoleStudentOrTutorGuardService,
    RoleAdministratorGuardService,
    RoleInstructorGuardService,
    RoleAdministratorOrTutorOrInstractorGuardService,
    RoleInstructorOrAdministratorGuardService,
    RoleTutorOrAdministratorGuardService,
    RoleTutorGuardService,
    LoggedGuardService,
    AuthGuardService,
  ],
  declarations: [
    AppComponent,
    OkModalComponent,
    DeleteModalComponent,
    KoModalComponent,
    OkModalPrenotazioneComponent,
    KoModalPrenotazioneComponent,
    WarningModalComponent,
    AnswerModalComponent,
    PrenotaProvaFinaleModalComponent,
    AddOraLaboratorioModalComponent,
    AddStudentProvaFinaleModalComponent,
    StoricoProvaFinaleModalComponent,
  ],
  exports: [SharedComponentsModule, MaterialModule],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
